import { openDB } from 'idb'
import type { SgIndexedDB } from '../models/IndexedDB'

declare global {
  interface Window {
    removeAutosaveItem: (key: string) => void
  }
}

export interface AutosaveInfo {
  key: string,
  fields: [string, FormDataEntryValue][],
  saveDate: number
}

export const initDB = () => {
  return openDB<SgIndexedDB>('stopgame', 1, {
    upgrade(upgradeDb) {
      upgradeDb.createObjectStore('autosave', {
        keyPath: 'key'
      })
    }
  })
}

export const storeAutosaveInDb = async (item: AutosaveInfo) => {
  try {
    const db = await initDB()
    return db.put<'autosave'>('autosave', item)
  } catch (e) {
    console.error(e)
  }
}

export const getAutosaveFromDb = async (key: string) => {
  try {
    const db = await initDB()
    return db.get<'autosave'>('autosave', key)
  } catch (e) {
    console.error(e)
  }
}

export const removeAutosaveFromDb = async (key: string) => {
  try {
    const db = await initDB()
    return db.delete('autosave', key)
  } catch (e) {
    console.error(e)
  }
}

window.removeAutosaveItem = (key: string) => {
  return removeAutosaveFromDb(key)
}
